import {connect} from "react-redux";
import {withTranslation} from "react-i18next";
import WishlistShareForm from "../../components/wishlist/WishlistShareForm";
import {resetMailing, submitWishlist} from "../../actions/mailing";
import type {ApplicationState} from "../../reducers";
import type {WishlistSharing} from "../../models/WishlistSharing";

function mapStateToProps(state: ApplicationState, ownProps) {
	return {
		products: state.bookmarks.products,
		contactData: state.mailing.contactData,
		sendSuccess: state.mailing.wishlistSuccess,
		sendError: state.mailing.wishlistError,
		captchaInvalid: state.mailing.invalidCaptcha,
		rateLimited: state.mailing.rateLimited,
		privacyNoteLinkUrl: state.config.privacyPolicyLink,
		locationChoices: state.location.locationChoices,
		pickupLocation: state.location.pickupLocation,
		isShopEnabled: state.config.isShopEnabled,
	};
}

function mapDispatchToProps(dispatch) {
	return {
		submitWishlist: (wishlist: WishlistSharing) => dispatch(submitWishlist(wishlist)),
		resetMailing: () => dispatch(resetMailing())
	};
}

export default withTranslation()(connect(mapStateToProps, mapDispatchToProps)(WishlistShareForm));
